module.exports = __webpack_public_path__ + "media/images/partners/nationwide-05329a0788a04e2b1c9fbeba9b34c6de.svg";